import {Option} from './option';
export interface ExportRecommandForwarderResponse {
    seqNo: number;
    facility: string;
    deliveryCountry: string;
    deliveryCountryChinese: string;
    deliveryCity: string;
    deliveryCityChinese: string;
    weightLowerLimit: number;
    weightUpperLimit: number;
    forwarderCode: string;
    direct: string;
    createUser: string;
    createDt: Date;
    updateUser: string;
    updateDt: Date;
    incoTerm: string[];
    rfqCountry: string;
    rfqCity:  string;
    rfqIncoTerm: string;
    citySeqNo: number;
    deliveryCountryShorthand: string;
    consigneeKey: string;
}
export class ExportRecommandForwarderDataTable {
    seqNo: number;
    facility: string;
    deliveryCountry: string;
    deliveryCountryChinese: string;
    deliveryCity: string;
    deliveryCityChinese: string;
    weightLowerLimit: number;
    weightUpperLimit: number;
    forwarderCode: string;
    direct: string;
    createUser: string;
    createDt: Date;
    updateUser: string;
    updateDt: Date;
    incoTerm: string[];
    rfqCountry: string;
    rfqCity:  string;
    rfqIncoTerm: string;
    citySeqNo: number;
    deliveryCountryShorthand: string;
    consigneeKey: string;

    constructor(data: ExportRecommandForwarderResponse) {
        this.seqNo = data.seqNo;
        this.facility = data.facility;
        this.deliveryCountry = data.deliveryCountry;
        this.deliveryCountryChinese = data.deliveryCountryChinese;
        this.deliveryCity = data.deliveryCity;
        this.deliveryCityChinese = data.deliveryCityChinese;
        this.weightLowerLimit = data.weightLowerLimit;
        this.weightUpperLimit = data.weightUpperLimit;
        this.forwarderCode = data.forwarderCode;
        this.direct = data.direct;
        this.createUser = data.createUser;
        this.createDt = data.createDt;
        this.updateUser = data.updateUser;
        this.updateDt = data.updateDt;
        this.incoTerm = data.incoTerm;
        this.rfqCountry = data.rfqCountry;
        this.rfqCity = data.rfqCity;
        this.rfqIncoTerm = data.rfqIncoTerm;
        this.citySeqNo = data.citySeqNo;
        this.deliveryCountryShorthand = data.deliveryCountryShorthand;
        this.consigneeKey = data.consigneeKey;
    }

    // 以下不是後端回傳的資訊，而是前端頁面使用的輔助欄位
    isForwarderExpress!: boolean;
}




